import MenuBarItem from "../models/layout/MenuBarItemModel";

const menubarItems: MenuBarItem[] = [
  {
    name: "Inicio",
    href: "/",
    icon: "fa-home",
  },
  {
    // Sin `roles`: políticas y objetivos de la empresa son para todo el personal.
    name: "Gerencia",
    group: "gerencia",
    href: "#gerencia",
    icon: "fa-university",
    subMenu: [
      { name: "Políticas de la Empresa", href: "/gerencia/politicas", icon: "fa-gavel" },
      { name: "Objetivos de Calidad", href: "/gerencia/objetivos-calidad", icon: "fa-bullseye" },
    ]
  },
  {
    name: "Dashboard Gerencia",
    group: "gerencia",
    href: "#dashboardGerencia",
    icon: "fa-tachometer",
    roles: ["ADMINISTRADOR", "AdminGerencia", "UsuarioGerencia"],
    subMenu: [
      { name: "Presupuesto", href: "/gerencia/presupuesto", icon: "fa-money", roles: ["ADMINISTRADOR", "AdminGerencia", "UsuarioGerencia"] },
      { name: "Cumplimiento de Presupuesto", href: "/gerencia/cumplimiento-presupuesto", icon: "fa-line-chart", roles: ["ADMINISTRADOR", "AdminGerencia", "UsuarioGerencia"] },
    ]
  },
  {
    // SIGED reemplaza la antigua «Plan Estratégico» del Dashboard Gerencia (2026-10-27).
    name: "SIGED Estratégico",
    group: "gerencia",
    href: "#siged",
    icon: "fa-line-chart",
    roles: ["ADMINISTRADOR", "AdminSIGED", "GrteSiged", "JcoSiged", "JefAreaSiged", "UserSiged"],
    subMenu: [
      { name: "SIGED 2025–2029", href: "/gerencia/siged", icon: "fa-flag-checkered", roles: ["ADMINISTRADOR", "AdminSIGED", "GrteSiged", "JcoSiged", "JefAreaSiged", "UserSiged"] },
    ]
  },
  {
    name: "SGI",
    group: "gestion",
    href: "#sgi",
    icon: "fa-shield",
    subMenu: [
      { name: "SGI Usuario", href: "/visor-sgi", icon: "fa-user", roles: ["ADMINISTRADOR", "PLANIFICACION", "USUARIO", "JEFETALLER", "JEFE CONTROL OPERACIONAL", "CALIDAD", "SUPERVISOR", "EXPEDITOR", "FINANZAS", "OPERARIO", "USUARIOSGI", "ADMINSGI"] },
      { name: "Admin SGI", href: "/admin-sgi", icon: "fa-user-secret", roles: ["ADMINISTRADOR", "ADMINSGI"] },
      { name: "No Conformidades", href: "/no-conformidades", icon: "fa-exclamation-triangle", roles: ["ADMINISTRADOR", "AdminNoConformidad", "UserNoConformidad"] },
      { name: "Codificación ISO 27001", href: "/codificacion-iso", icon: "fa-sitemap", roles: ["ADMINISTRADOR", "AdminCodigosISO", "UsuarioCodigosISO"] },
      { name: "Herramientas SGI Gerencia", href: "/herramientas-sgi-gerencia", icon: "fa-briefcase", roles: ["ADMINISTRADOR", "AdminHtasGrcia", "UsuarioHtasGrcia"] },
      { name: "Admin Herramientas SGI Gerencia", href: "/herramientas-sgi-gerencia-admin", icon: "fa-tachometer", roles: ["ADMINISTRADOR", "AdminHtasGrcia"] },
      // Subgrupo de herramientas ISO 9001. Sin `roles`: se ve si el usuario
      // ve al menos una de sus pantallas (filterItems descarta el grupo vacío).
      {
        name: "Gestión de Calidad",
        href: "#gestion-calidad",
        icon: "fa-check-square-o",
        subMenu: [
          // Roles comunes a todas las herramientas: AdminGestCalidad / UsuarioGestCalidad.
          // Las áreas tienen una pantalla por herramienta; el administrador, una
          // sola con todas en pestañas (las antiguas «Admin …» redirigen ahí).
          // Orden pedido por el usuario (2026-10-08); las pestañas del admin lo siguen.
          { name: "Análisis FODA", href: "/analisis-foda", icon: "fa-th-large", roles: ["ADMINISTRADOR", "AdminGestCalidad", "UsuarioGestCalidad"] },
          { name: "Objetivos de Calidad", href: "/objetivos-calidad", icon: "fa-bullseye", roles: ["ADMINISTRADOR", "AdminGestCalidad", "UsuarioGestCalidad"] },
          { name: "Matrices de Riesgos", href: "/matrices-riesgo", icon: "fa-table", roles: ["ADMINISTRADOR", "AdminGestCalidad", "UsuarioGestCalidad"] },
          { name: "Mapas de Procesos", href: "/mapas-procesos", icon: "fa-sitemap", roles: ["ADMINISTRADOR", "AdminGestCalidad", "UsuarioGestCalidad"] },
          { name: "Partes Interesadas", href: "/partes-interesadas", icon: "fa-users", roles: ["ADMINISTRADOR", "AdminGestCalidad", "UsuarioGestCalidad"] },
          { name: "Admin Gestión de Calidad", href: "/gestion-calidad-admin", icon: "fa-tachometer", roles: ["ADMINISTRADOR", "AdminGestCalidad"] }
        ]
      }
    ]
  },
  {
    name: "Planificación",
    group: "operaciones",
    href: "#planificacion",
    icon: "fa-calendar-check-o",
    subMenu: [
      { name: "Planificaciones", href: "/planificacionesERP", icon: "fa-calendar", roles: ["ADMINISTRADOR", "PLANIFICACION", "JEFETALLER", "JEFE CONTROL OPERACIONAL", "SUPERVISOR", "USUARIO", "EXPEDITOR", "OPERARIO"] },
      { name: "8 Dimensiones", href: "/8-dimensiones", icon: "fa-th", roles: ["ADMINISTRADOR", "PLANIFICACION", "JEFETALLER", "JEFE CONTROL OPERACIONAL", "SUPERVISOR", "EXPEDITOR", "METROLOGIA", "OPERARIO"] },
      { name: "Apertura de OP", href: "/aperturaOP", icon: "fa-folder-open", roles: ["ADMINISTRADOR", "PLANIFICACION"] },
      // Entrega de Turno: solo ADMINISTRADOR y la cuenta de los jefes de turno.
      { name: "Entrega de Turno", href: "/entrega-turno", icon: "fa-exchange", roles: ["ADMINISTRADOR", "EntregaTurno"] },
    ]
  },
  {
    name: "Centro de Reparaciones",
    group: "operaciones",
    href: "#operaciones",
    icon: "fa-cogs",
    subMenu: [
      { name: "Estatus General", href: "/ordenesProceso", icon: "fa-list-alt", roles: ["ADMINISTRADOR", "PLANIFICACION", "USUARIO", "JEFETALLER", "JEFE CONTROL OPERACIONAL", "OPERARIO", "CALIDAD", "FINANZAS", "SUPERVISOR", "EXPEDITOR"] },
      { name: "QR Componentes", href: "/componentesQR", icon: "fa-qrcode", roles: ["ADMINISTRADOR", "PLANIFICACION", "CALIDAD"] },
      { name: "Componentes", href: "/componentes", icon: "fa-cubes", roles: ["ADMINISTRADOR", "PLANIFICACION", "USUARIO", "JEFETALLER", "JEFE CONTROL OPERACIONAL", "CALIDAD", "SUPERVISOR", "EXPEDITOR"] }
    ]
  },
  {
    name: "VPI Torno Balanceo",
    group: "operaciones",
    href: "#vpiTornoBalanceo",
    icon: "fa-cog",
    roles: ["ADMINISTRADOR", "PLANIFICACION", "JEFETALLER", "JEFE CONTROL OPERACIONAL", "SUPERVISOR", "EXPEDITOR", "METROLOGIA", "OPERARIO"],
    subMenu: [
      { name: "Dashboard", href: "/vpi-torno-balanceo/dashboard", icon: "fa-bar-chart", roles: ["ADMINISTRADOR", "PLANIFICACION", "JEFETALLER", "JEFE CONTROL OPERACIONAL", "SUPERVISOR", "EXPEDITOR", "METROLOGIA", "OPERARIO"] },
      { name: "Planificaciones", href: "/vpi-torno-balanceo", icon: "fa-calendar", roles: ["ADMINISTRADOR", "PLANIFICACION", "JEFETALLER", "JEFE CONTROL OPERACIONAL", "SUPERVISOR", "EXPEDITOR", "METROLOGIA", "OPERARIO"] },
    ]
  },
  {
    name: "Calidad",
    group: "operaciones",
    href: "#calidad",
    icon: "fa-check-circle",
    roles: ["ADMINISTRADOR", "JEFETALLER", "JEFE CONTROL OPERACIONAL", "USUARIO", "PLANIFICACION", "OPERARIO", "CALIDAD", "FINANZAS", "SUPERVISOR", "EXPEDITOR", "METROLOGIA"],
    subMenu: [
      { name: "Dashboards", href: "/calidad/dashboards", icon: "fa-bar-chart", roles: ["ADMINISTRADOR", "JEFETALLER", "JEFE CONTROL OPERACIONAL", "USUARIO", "PLANIFICACION", "OPERARIO", "CALIDAD", "FINANZAS", "SUPERVISOR", "EXPEDITOR", "METROLOGIA"] },
      { name: "Liberaciones", href: "/calidad/liberaciones", icon: "fa-check-square-o", roles: ["ADMINISTRADOR", "JEFETALLER", "JEFE CONTROL OPERACIONAL", "USUARIO", "PLANIFICACION", "OPERARIO", "CALIDAD", "FINANZAS", "SUPERVISOR", "EXPEDITOR", "METROLOGIA"] },
      { name: "Inspecciones Intermedias", href: "/calidad/inspecciones-intermedias", icon: "fa-search", roles: ["ADMINISTRADOR", "JEFETALLER", "JEFE CONTROL OPERACIONAL", "USUARIO", "PLANIFICACION", "OPERARIO", "CALIDAD", "FINANZAS", "SUPERVISOR", "EXPEDITOR", "METROLOGIA"] },
      { name: "Reprocesos", href: "/calidad/reprocesos", icon: "fa-repeat", roles: ["ADMINISTRADOR", "JEFETALLER", "JEFE CONTROL OPERACIONAL", "USUARIO", "PLANIFICACION", "OPERARIO", "CALIDAD", "FINANZAS", "SUPERVISOR", "EXPEDITOR", "METROLOGIA"] },
      { name: "Análisis de Garantía", href: "/calidad/analisis-garantia", icon: "fa-shield", roles: ["ADMINISTRADOR", "JEFETALLER", "JEFE CONTROL OPERACIONAL", "USUARIO", "PLANIFICACION", "OPERARIO", "CALIDAD", "FINANZAS", "SUPERVISOR", "EXPEDITOR", "METROLOGIA"] },
    ]
  },
  {
    name: "Servicios a Terreno",
    group: "operaciones",
    href: "#serviciosTerreno",
    icon: "fa-truck",
    subMenu: [
      { name: "Dashboard", href: "/dashboard-servicios-terreno", icon: "fa-bar-chart", roles: ["ADMINISTRADOR", "ADMINSOLICITUDES", "JEFETALLER", "JEFE CONTROL OPERACIONAL", "SUPERVISOR", "EXPEDITOR", "PLANIFICACION", "TERRENO"] },
      { name: "Solicitud de Servicio", href: "/solicitud-servicio", icon: "fa-file-text-o", roles: ["ADMINISTRADOR", "ADMINSOLICITUDES", "JEFETALLER", "JEFE CONTROL OPERACIONAL", "SUPERVISOR", "EXPEDITOR", "PLANIFICACION", "TERRENO"] },
      { name: "Catálogo Subcomp./Servicios", href: "/catalogo-servicios-terreno", icon: "fa-list-alt", roles: ["ADMINISTRADOR", "ADMINCATALOGO"] },
      { name: "Visitas a Terreno", href: "/en-construccion", icon: "fa-street-view" },
      { name: "Informes de Medición", href: "/en-construccion", icon: "fa-tachometer" },
      { name: "Escaneo 3D", href: "/en-construccion", icon: "fa-cube" },
    ]
  },
  {
    name: "Área Vibraciones",
    group: "operaciones",
    href: "#areaVibraciones",
    icon: "fa-signal",
    roles: ["ADMINISTRADOR", "ADMINVIBRAC", "USERVIBRAC"],
    subMenu: [
      { name: "Análisis de Vibraciones", href: "/analisis-vibraciones", icon: "fa-area-chart", roles: ["ADMINISTRADOR", "ADMINVIBRAC", "USERVIBRAC"] },
      { name: "Configuración de Avisos", href: "/avisos-vibraciones", icon: "fa-envelope-o", roles: ["ADMINISTRADOR", "ADMINVIBRAC"] },
    ]
  },
  {
    name: "Área Comercial",
    group: "gestion",
    href: "#areaComercial",
    icon: "fa-handshake-o",
    subMenu: [
      { name: "Estatus Entregas", href: "/estatus-entregas", icon: "fa-check-circle", roles: ["ADMINISTRADOR", "COMERCIAL"] },
      { name: "Estatus Encuestas", href: "/en-construccion", icon: "fa-star" },
    ]
  },
  {
    name: "Ingeniería",
    group: "operaciones",
    href: "#ingenieria",
    icon: "fa-wrench",
    roles: ["ADMINISTRADOR", "AdminProyInge", "UserProyInge"],
    subMenu: [
      { name: "Gestión de Proyectos", href: "/gestion-proyectos", icon: "fa-briefcase", roles: ["ADMINISTRADOR", "AdminProyInge", "UserProyInge"] },
    ]
  },
  {
    name: "Informática",
    group: "gestion",
    href: "#informatica",
    icon: "fa-laptop",
    // La sección NO declara `roles`: cada ítem trae los suyos y `filterItems`
    // oculta la sección cuando todos sus hijos quedan filtrados. Así los roles
    // de Planner TI ven la sección con SOLO su ítem, sin ganar acceso al
    // Inventario de Hardware (y al revés).
    subMenu: [
      { name: "Inventario de Hardware", href: "/inventario-hardware", icon: "fa-microchip", roles: ["ADMINISTRADOR", "AdminTI", "UserTi"] },
      { name: "Servicios de Software", href: "/servicios-software", icon: "fa-cloud", roles: ["ADMINISTRADOR", "AdminSoftTi", "UserSoftTi"] },
      { name: "Reporte de Bugs", href: "/reporte-bugs", icon: "fa-bug" },
      { name: "Admin Reporte de Bugs", href: "/reporte-bugs-admin", icon: "fa-wrench", roles: ["ADMINISTRADOR", "AdminRpteBugs"] },
      { name: "Planner TI", href: "/planner-ti", icon: "fa-calendar-check-o", roles: ["ADMINISTRADOR", "AdminPlannerTi", "PersPlannerTi", "UserPlannerTi"] },
    ]
  },
  {
    name: "Laboratorio",
    group: "operaciones",
    href: "#laboratorio",
    icon: "fa-hdd-o",
    subMenu: [
      { name: "Estatus", href: "/laboratorio/ordenesProceso", icon: "fa-list-alt" },
      { name: "Planificaciones", href: "/laboratorio/planificaciones", icon: "fa-calendar", roles: ["ADMINISTRADOR", "PLANIFICACION", "JEFETALLER", "JEFE CONTROL OPERACIONAL", "SUPERVISOR", "EXPEDITOR", "METROLOGIA", "OPERARIO"] },
      { name: "Solicitudes TOT Interno", href: "/laboratorio/tot-interno", icon: "fa-file-text-o", roles: ["ADMINISTRADOR", "TOTLAB", "USUARIOTOTLAB"] },
      { name: "Catálogo TOT Interno", href: "/laboratorio/catalogo-tot", icon: "fa-list-alt", roles: ["ADMINISTRADOR", "ADMINCATALOGOTOTLAB"] },
      { name: "Informes", href: "/en-construccion", icon: "fa-file-text-o" },
      { name: "Configuraciones", href: "/laboratorio/configuraciones", icon: "fa-cogs", roles: ["ADMINISTRADOR", "PLANIFICACION", "JEFETALLER", "JEFE CONTROL OPERACIONAL"] },
    ]
  },
  {
    name: "Seguridad",
    group: "seguridad",
    href: "#seguridad",
    icon: "fa-exclamation-triangle",
    subMenu: [
      // Sin `roles`: crear y consultar reportes flash está abierto a cualquier
      // usuario autenticado del ERP. El backend tampoco exige rol en esas rutas.
      { name: "Reportes Flash", href: "/reportes-flash", icon: "fa-bolt" },
      { name: "Admin Reportes Flash", href: "/reportes-flash-admin", icon: "fa-cogs", roles: ["ADMINISTRADOR", "AdminRepFlash"] },
      // Sin `roles`: cumplir la cuota mensual de cursos le toca a todo el
      // personal, y una lista de roles dejaría fuera los que se creen después.
      // El backend tampoco exige rol para el propio cumplimiento.
      { name: "Cursos de Seguridad", href: "/cursos-seguridad", icon: "fa-graduation-cap" },
      { name: "Admin Cursos de Seguridad", href: "/cursos-seguridad-admin", icon: "fa-check-square-o", roles: ["ADMINISTRADOR", "AdminCursosSeg"] },
      { name: "Herramientas Preventivas", href: "/herramientas-preventivas", icon: "fa-shield", roles: ["ADMINISTRADOR", "AdminHtasPrev", "UserHtasPrev"] },
      { name: "Admin Herr. Preventivas", href: "/herramientas-preventivas-admin", icon: "fa-bar-chart", roles: ["ADMINISTRADOR", "AdminHtasPrev"] },
      { name: "Control JCO", href: "/herramientas-preventivas-jco", icon: "fa-binoculars", roles: ["ADMINISTRADOR", "AdminHtasPrev", "Jco1HtasPrev", "Jco2HtasPrev", "Jco3HtasPrev", "Jco4HtasPrev"] },
      { name: "AST", href: "/en-construccion", icon: "fa-clipboard" }
    ]
  },
  {
    name: "Mejora Continua",
    group: "gestion",
    href: "#mejora",
    icon: "fa-line-chart",
    subMenu: [
      { name: "Rentabilidad", href: "/en-construccion", icon: "fa-money" },
      { name: "Visualización TOT", href: "/tot-view", icon: "fa-eye" },
      { name: "Programación Diaria TOT", href: "/tot", icon: "fa-calendar-check-o", roles: ["ADMINISTRADOR", "AdminPlaniTotDiario"] },
      { name: "Admin Listas TOT", href: "/tot-admin", icon: "fa-list", roles: ["ADMINISTRADOR", "AdminPlaniTotDiario"] },
    ]
  },
  {
    name: "Servicios Generales",
    group: "logistica",
    href: "#servicios",
    icon: "fa-building",
    subMenu: [
       { name: "Plan Mantenimiento de Equipos", href: "/en-construccion", icon: "fa-clipboard" },
       { name: "Carga Combustible Generador 400KVA", href: "/carga-combustible-generador", icon: "fa-tint", roles: ["ADMINISTRADOR", "AdminCargaCombGen", "UserCargaCombGen"] },
       { name: "Casilleros", href: "/casilleros", icon: "fa-lock" },
       { name: "Admin Casilleros", href: "/casilleros-admin", icon: "fa-lock", roles: ["ADMINISTRADOR", "ADMINCASILLEROS"] },
       { name: "Extintores", href: "/extintores", icon: "fa-fire-extinguisher" },
       { name: "Admin Extintores", href: "/extintores-admin", icon: "fa-fire-extinguisher", roles: ["ADMINISTRADOR", "ADMINEXT"] },
       { name: "Solicitud Préstamo de Vehículos", href: "/prestamo-vehiculos", icon: "fa-car", roles: ["ADMINISTRADOR", "AdminPrestVehic", "UserPrestVehic"] },
       { name: "Admin Préstamo de Vehículos", href: "/prestamo-vehiculos-admin", icon: "fa-tachometer", roles: ["ADMINISTRADOR", "AdminPrestVehic"] },
       { name: "Gestión de Vehículos", href: "/gestion-vehiculos", icon: "fa-wrench", roles: ["ADMINISTRADOR", "AdminPrestVehic"] },
       { name: "Infraestructura", href: "/en-construccion", icon: "fa-industry" }
    ]
  },
  {
    name: "Recursos",
    group: "logistica",
    href: "#recursos",
    icon: "fa-users",
    subMenu: [
       { name: "Minuta Reuniones", href: "/en-construccion", icon: "fa-file-text" },
       { name: "Reserva de Salas", href: "/reserva-salas", icon: "fa-calendar-check-o" },
       { name: "Admin Salas", href: "/reserva-salas-admin", icon: "fa-clipboard-check", roles: ["ADMINISTRADOR", "ADMINSALAS"] }
    ]
  },
  {
    name: "Configuración",
    group: "sistema",
    href: "#configuracion",
    icon: "fa-sliders",
    subMenu: [
      { name: "Usuarios", href: "/users", icon: "fa-user-circle", roles: ["ADMINISTRADOR"] },
      { name: "Clientes", href: "/clientes", icon: "fa-address-book", roles: ["ADMINISTRADOR", "PLANIFICACION", "JEFE CONTROL OPERACIONAL"] },
      { name: "Planificaciones Históricas", href: "/planificaciones-historicas", icon: "fa-history", roles: ["ADMINISTRADOR"] },
      { name: "Metas Objetivo Planificación", href: "/metas-objetivo-planificacion", icon: "fa-bullseye", roles: ["ADMINISTRADOR"] },
      { name: "Configuración de Programación", href: "/configuracion-programacion", icon: "fa-wrench", roles: ["ADMINISTRADOR"] },
      { name: "Reglas de Equipos de Trabajo", href: "/configuracion-parejas", icon: "fa-users", roles: ["ADMINISTRADOR"] },
      { name: "Configuraciones ERP", href: "/settingsPage", icon: "fa-cog", roles: ["ADMINISTRADOR", "JEFETALLER", "JEFE CONTROL OPERACIONAL", "SUPERVISOR", "ADMINSALAS"] },
      { name: "Logs", href: "/logs", icon: "fa-file-text-o", roles: ["ADMINISTRADOR"] },
      { name: "Econnect", href: "/econnect", icon: "fa-exchange", roles: ["ADMINISTRADOR"] },
      { name: "Respaldos DB", href: "/backup", icon: "fa-database", roles: ["ADMINISTRADOR", "PLANIFICACION", "CALIDAD", "JEFETALLER", "JEFE CONTROL OPERACIONAL", "EXPEDITOR"] },
      { name: "Mi Cuenta", href: "/en-construccion", icon: "fa-id-card" } 
    ]
  },
];

function filterItems(items: MenuBarItem[], userRol: string[]): MenuBarItem[] {
  return items
    .filter((item) => {
      if (!item.roles) return true;

      return userRol.some((rol) => {
        if (rol.includes("OPERARIO")) {
          return item.roles?.includes("OPERARIO");
        }
        return item.roles?.includes(rol);
      });
    })
    .map((item) => ({
      ...item,
      subMenu: item.subMenu ? filterItems(item.subMenu, userRol) : undefined,
    }))
    .filter((item) => !item.subMenu || item.subMenu.length > 0);
}

export default function getMenuBarItems(userRol: string[]): MenuBarItem[] {
  return filterItems(menubarItems, userRol);
}
